import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgKey = function SvgKey(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_19_414)",
        fillOpacity: 0.16,
        d: "M24.803 63q-7.418 0-12.61-5.1Q7 52.8 7 45.517t5.193-12.4T24.803 28q5.656 0 10.086 2.975t6.368 8.205H73.25q.435 0 .861.175t.798.54l4.364 4.29q.372.366.55.789t.178.93q0 .506-.188.92a2.9 2.9 0 0 1-.571.807l-7.492 6.807a1.6 1.6 0 0 1-.688.529q-.42.172-.867.172-.445 0-.81-.088a2.2 2.2 0 0 1-.744-.35l-4.84-3.5-5.41 3.79q-.369.262-.729.316t-.737.054q-.375 0-.743-.098a2.1 2.1 0 0 1-.654-.293l-4.457-3.15h-9.812q-1.747 4.847-6.132 8.013Q30.74 63 24.803 63"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_19_414)",
        d: "M21.574 45.296q-1.56 0-2.693-1.113-1.13-1.113-1.13-2.669 0-1.555 1.116-2.683t2.678-1.127 2.692 1.113 1.131 2.669q0 1.555-1.117 2.683t-2.677 1.127M21.559 59q-7.315 0-12.438-5.1Q4 48.8 4 41.517t5.121-12.4T21.56 24q5.58 0 9.948 2.975 4.37 2.975 6.281 8.205h31.553q.43 0 .85.175t.787.54l4.304 4.29q.367.366.542.789t.176.93q0 .506-.186.92a2.9 2.9 0 0 1-.563.807l-7.39 6.807a1.57 1.57 0 0 1-.677.529 2.2 2.2 0 0 1-.855.172q-.44 0-.8-.088a2.2 2.2 0 0 1-.733-.35l-4.775-3.5-5.335 3.79q-.363.262-.719.316-.355.054-.727.054-.371 0-.732-.098a2.1 2.1 0 0 1-.645-.293l-4.397-3.15h-9.678q-1.722 4.847-6.048 8.013Q27.415 59 21.56 59m0-2.692q5.228 0 9.158-3.302 3.93-3.3 5.012-7.878h12.723l4.876 3.533h-.034.044-.01l6.78-4.772 6.12 4.618 6.922-6.71-3.937-3.925H35.742q-.986-4.43-4.883-7.804-3.897-3.376-9.282-3.376-6.198 0-10.536 4.314Q6.7 35.32 6.7 41.49t4.332 10.494q4.332 4.325 10.526 4.325"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_19_414",
        x1: 7.762,
        x2: 78.984,
        y1: 45.5,
        y2: 45.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_19_414",
        x1: 4.752,
        x2: 74.998,
        y1: 41.5,
        y2: 41.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgKey as ReactComponent };
//# sourceMappingURL=Key.svg.es.js.map
